import { AzureCommunicationTokenCredential, CommunicationUserIdentifier } from '@azure/communication-common';
import {
  CallAdapter,
  CallComposite,
  CallCompositeOptions,
  useAzureCommunicationCallAdapter,
  fromFlatCommunicationIdentifier,
  COMPOSITE_LOCALE_PT_BR,
  DEFAULT_COMPOSITE_ICONS,
  CallCompositePage
} from '@azure/communication-react';
import React, { useMemo, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import '../../pages/ComunicacaoPage/ComunicacaoPage.css';
import * as comunicacaoService from "../../services/ComunicacaoService";

const modalStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 300,
  bgcolor: 'background.paper',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  display: 'flex',
  borderRadius: 4,
  flexDirection: 'column'
};

export type ChamadaProps = {
  userIdentifier: string;
  token: string;
  link: string;
  displayName: string;
  avatarInitials?: string;
  formFactor?: 'desktop' | 'mobile';
  options: CallCompositeOptions;
  lobby?: LobbyProps;
};

export type LobbyProps = {
  mensagemLobby?: string;
  imagemLobby?: string;
};

export const ChamadaContainer = (props: ChamadaProps): JSX.Element => {
  let locale = COMPOSITE_LOCALE_PT_BR;
  let icons = DEFAULT_COMPOSITE_ICONS;
  const [open, setOpen] = useState(false);

  //Personalização tela de entrada
  if (props.lobby?.mensagemLobby) {
    locale.strings.call.lobbyScreenWaitingToBeAdmittedTitle = props.lobby?.mensagemLobby;
    locale.strings.call.lobbyScreenConnectingToCallTitle = props.lobby?.mensagemLobby;
  }


  if (props.lobby?.imagemLobby) {
    icons.LobbyScreenConnectingToCall = <img alt="" src={`data:image/jpeg;base64,${props.lobby?.imagemLobby}`} />
    icons.LobbyScreenWaitingToBeAdmitted = <img alt="" src={`data:image/jpeg;base64,${props.lobby?.imagemLobby}`} />

  }

  const userId = useMemo(
    () => fromFlatCommunicationIdentifier(props.userIdentifier) as CommunicationUserIdentifier,
    [props.userIdentifier]
  );

  const tokenRefresher = async (): Promise<string> => {
    const tokenResponse = await comunicacaoService.GetUserAcs();
    return tokenResponse.resultado.token;
  };

  const credential = useMemo(() => new AzureCommunicationTokenCredential({
    token: props.token,
    tokenRefresher: tokenRefresher,
    refreshProactively: true
  }), [props.token]);

  const locator = useMemo(
    () => (isTeamsMeetingLink(props.link) ? { meetingLink: props.link } : { groupId: props.link }),
    [props.link]
  );
  const adapter = useAzureCommunicationCallAdapter(
    {
      userId: userId,
      displayName: props.displayName,
      credential,
      locator,
    },
    undefined,
    async (adapter: CallAdapter): Promise<void> => {
      await adapter.leaveCall().catch((e) => {
        console.error('Falha ao carregar chamada.', e);
      });
    }
  );

  const handleClose = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, reason: any) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  const handleSair = () => {
    setOpen(false);
    comunicacaoService.PostLogReuniao(localStorage.getItem('idReuniao') as string, localStorage.getItem('idAtor') as string, 'S');
    window.parent.postMessage("call:ended", "*");
    localStorage.setItem("exibePesquisaSatisfacao", "false");
    adapter?.leaveCall().catch((e) => {
      console.error(e);
    });
  };

  if (adapter) {
    adapter.on('callEnded', (event) => {
      comunicacaoService.PostLogReuniao(localStorage.getItem('idReuniao') as string, localStorage.getItem('idAtor') as string, 'S');
      window.parent.postMessage("call:ended", "*");
      return window.location.href = '?Instance=RmVlZGJhY2tQYWdl'; //FeedbackPage
    })

    adapter.on("participantsJoined", (event) => { setOpen(false); });

    adapter.onStateChange((state) => {
      if (state.page === "lobby" as CallCompositePage && (props.lobby?.mensagemLobby || props.lobby?.imagemLobby)) {
        setOpen(true);
      }
      if (state.call && Array.isArray(state.call?.remoteParticipants) && state.call.remoteParticipants.length > 1) {
        setOpen(false);
      }
    })
  }

  return (
    <div style={{ height: '100dvh', width: '100vw' }}>
      {adapter && (

        <CallComposite
          adapter={adapter}
          locale={locale}
          formFactor={props?.formFactor}
          options={props?.options}

        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...modalStyle, width: 300 }}>
          <img className="image-start" alt="" src={`data:image/jpeg;base64,${props.lobby?.imagemLobby}`} />
          <div className="modal-message">
            {props.lobby?.mensagemLobby}
          </div>
          <div className="modal-buttons" >
            <Button onClick={handleSair} style={{
              textTransform: 'capitalize', fontWeight: 'bold', minWidth: 130, backgroundColor: "#000080", color: 'white'
            }} variant="contained" disableRipple>Voltar</Button>
      
          </div>

        </Box>

      </Modal>
    </div>
  );
};

const isTeamsMeetingLink = (link: string): boolean => link.startsWith('https://teams.microsoft.com/l/meetup-join');
